import Gallery from "../blocks/gallery";

const Default = {
  init() {
    new Gallery(".gallery");
  },

};

export default Default;